<ng-select
  [formControl]="formControl"
  [items]="data$ | async"
  [loading]="loading$ | async"
  [multiple]="true"
  [searchable]="true"
  bindLabel="fullName"
  bindValue="id"
  appendTo="body"
  placeholder="{{ 'widgetType-MarketCustomerAnalysis.kam' | transloco }}"
  (search)="searchTerm$.next($event.term)"
></ng-select>
